export enum RoundType {
    GameRound,
    ProgressiveBonus,
    FreeRoundOffer
}

export function getRoundTypeValue(stringValue: string): RoundType {
    var returnValue: RoundType;
    if (stringValue === "GameRound") {
        returnValue = RoundType.GameRound;
    }
    else if (stringValue === "ProgressiveBonusWin") {
        returnValue = RoundType.ProgressiveBonus;
    }
    else if (stringValue === "FreeRoundOffer") {
        returnValue = RoundType.FreeRoundOffer;
    }

    return returnValue;
}



/** WEBPACK FOOTER **
 ** ./Typescript/Models/RoundTypeEnum.ts
 **/